import { useProctorGroups } from '@indeed/frontend-proctor-utils';

/**
 * Hook to determine if the Apply For Me rebranding (Auto Apply → Apply For Me)
 * should be applied.
 *
 * Uses proctor test: auto_apply_rebranding_tst
 * - value === 1: SHOW new "Apply For Me" branding
 * - value !== 1: SHOW legacy "Auto Apply" branding
 */
export const useIsApplyForMeRebrandingEnabled = (): boolean => {
    const { getGroup } = useProctorGroups();
    return getGroup('auto_apply_rebranding_tst')?.value === 1;
};
